/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Shop_Shipped_OnInputs */

const en_shop_shipped_on = /** @type {(inputs: Shop_Shipped_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sent ${i?.date}`)
};

const pl_shop_shipped_on = /** @type {(inputs: Shop_Shipped_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wysłano ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Sent {date}" |
*
* @param {Shop_Shipped_OnInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const shop_shipped_on = /** @type {((inputs: Shop_Shipped_OnInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Shipped_OnInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_shop_shipped_on(inputs)
	return en_shop_shipped_on(inputs)
});